import { Api } from '@axiom/ui';
import type { Candidate, Event } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

class TalentActivitiesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readActivities(candidateId: Candidate['id']) {
    return super.read<{ data: Event[] }>({
      endpoint: `/candidates/${candidateId}/events`,
      method: 'GET',
    });
  }

  async refreshActivities(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/events`);
  }

  refreshAllActivities() {
    return super.invalidateAll();
  }
}

export const TalentActivitiesApi = new TalentActivitiesApiClass();

const api = new LegacyApiHelper('talent-activities');

export const getActivitiesByTalentId = async (candidateID: Candidate['id']) => {
  const response = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/candidates/${candidateID}/events`
  );
  return { data: response.data };
};
